<template>
  <component
    :is="device"
    ref="lpuSchedule"
    v-model="lpuScheduleModel"
    :schedule="selectedSchedule"
    :loading="isLoading"
  />
</template>

<script>
import { getLpuSchedule } from 'www/vue_components/common/LpuSchedule/api'
import { TARGET_ATTR_CACHED_NAME } from 'www/vue_components/common/LpuSchedule/constants'

export default {
  name: 'LpuSchedule',
  components: {
    mobile: () => import(/* webpackMode: "eager" */'www/vue_components/common/LpuSchedule/components/mobile/LpuSchedule.vue'),
    desktop: () => import(/* webpackMode: "eager" */'www/vue_components/common/LpuSchedule/components/desktop/LpuSchedule.vue'),
  },
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    /**
     * interface
     * schedules: Schedules
     * selectedSchedule: Schedule
     */
    schedules: new Map(),
    isLoading: true,
    lpuScheduleModel: false,
    selectedSchedule: {},
    device: window.MOBILE_VERSION ? 'mobile' : 'desktop',
  }),
  mounted() {
    window.addEventListener('lpu-schedule:selected', this.handleLpuScheduleSelected)
  },
  methods: {
    handleLpuScheduleSelected({ detail }) {
      const { addressId, tooltip } = detail

      this.lpuScheduleModel = true

      const selectedSchedule = this.schedules.get(addressId)

      // Если получили объект, значит расписание уже есть, берём его.
      if (typeof selectedSchedule === 'object') {
        this.selectedSchedule = selectedSchedule

        if (tooltip) {
          this.updateTooltipContent({
            tooltip,
            cached: true,
          })
        }

        return
      }

      /**
       * Чтобы не спамить запросами для одного и того же расписания, пока он выполняется,
       * проверяем истинность selectedSchedule.
       * `false` - запрос ещё не завершён, ждём завершения.
       * `true` - запрос завершился (но неудачно), создаём новый запрос.
       */
      if (typeof selectedSchedule === 'boolean' && !selectedSchedule) {
        return
      }

      this.schedules.set(addressId, false)
      this.isLoading = true

      if (tooltip) {
        this.updateTooltipContent({ tooltip, cached: false })
      }

      getLpuSchedule({ url: this.url, addressId })
        .then(({ data }) => {
          this.schedules.set(addressId, data)
          this.selectedSchedule = data
          this.isLoading = false

          if (tooltip) {
            this.updateTooltipContent({
              tooltip,
              cached: true,
            })
          }
        })
        .catch(() => {
          this.schedules.set(addressId, true)
        })
    },
    updateTooltipContent({ tooltip, cached = false }) {
      /**
       * Необходимо подождать, пока не будет отрисовано новое расписание,
       * прежде чем передавать контент
       */
      this.$nextTick(() => {
        tooltip.setContent(this.$refs.lpuSchedule.$el.innerHTML)
        tooltip.reference.setAttribute(TARGET_ATTR_CACHED_NAME, cached)
      })
    },
  },
}
</script>
